// extracted by mini-css-extract-plugin
export default {"tooth":"Tooth_tooth__B8dXs","selected":"Tooth_selected__anzCr","error":"Tooth_error__YspyZ"};